/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_st_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Its population standard deviation is 2.`)
};

const es_st_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su desviación estándar poblacional es 2.`)
};

const de_st_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Standardabweichung dieser Grundgesamtheit beträgt 2.`)
};

const nl_st_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De standaardafwijking van de populatie is 2.`)
};

const fr_st_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son écart-type de population est 2.`)
};

const it_st_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La sua deviazione standard di popolazione è 2.`)
};

const pt_br2_st_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O desvio padrão populacional dele é 2.`)
};

const pt_st_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O seu desvio-padrão populacional é 2.`)
};

const ja_st_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この集合の母標準偏差は2です。`)
};

const zh_st_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其总体标准差为 2。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const st_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.st_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("st_ex3", locale)
	if (locale === "en") return en_st_ex3(inputs)
	if (locale === "es") return es_st_ex3(inputs)
	if (locale === "de") return de_st_ex3(inputs)
	if (locale === "nl") return nl_st_ex3(inputs)
	if (locale === "fr") return fr_st_ex3(inputs)
	if (locale === "it") return it_st_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_st_ex3(inputs)
	if (locale === "pt") return pt_st_ex3(inputs)
	if (locale === "ja") return ja_st_ex3(inputs)
	return zh_st_ex3(inputs)
};